import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Header.css';
function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isEquipmentDropdownOpen, setIsEquipmentDropdownOpen] = useState(false);
  const navRef = useRef(null);
  const menuToggleRef = useRef(null);
  const equipmentDropdownRef = useRef(null);

  const toggleMenu = () => {
    setIsMenuOpen((open) => !open);
  };

  const toggleEquipmentDropdown = () => {
    setIsEquipmentDropdownOpen((open) => !open);
  };

  const handleNavClick = () => {
    setIsMenuOpen(false); // Close mobile menu
    setIsEquipmentDropdownOpen(false); // Close equipment dropdown
    window.scrollTo({
      // Scroll to top
      top: 0,
      behavior: 'smooth', // Smooth animation
    });
  };

  useEffect(() => {
    if (!isMenuOpen && !isEquipmentDropdownOpen) return;
    function handleClickOutside(event) {
      // Check if the clicked element is a navigation link
      const isNavLink = event.target.closest('nav a:not(.dropdown-menu a)');

      if (
        navRef.current &&
        !navRef.current.contains(event.target) &&
        menuToggleRef.current &&
        !menuToggleRef.current.contains(event.target)
      ) {
        setIsMenuOpen(false);
      }
      if (equipmentDropdownRef.current && !equipmentDropdownRef.current.contains(event.target)) {
        // If it's a nav link, don't close dropdown (let navigation happen first)
        if (!isNavLink) {
          setIsEquipmentDropdownOpen(false);
        }
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen, isEquipmentDropdownOpen]);

  return (
    <header className="header">
      <div className="container">
        {/* Desktop layout: logo left, nav center, icons right */}
        <div className="logo">
          <Link to="/" onClick={handleNavClick}>
            <img src="/images/logo/megaton-logo.png" alt="MEGATON" />
            <p>Serviços de Munck & Guindaste</p>
          </Link>
        </div>

        <nav ref={navRef} className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
          <ul>
            <li>
              <Link to="/" onClick={handleNavClick}>
                Home
              </Link>
            </li>
            <li>
              <Link to="/quem-somos" onClick={handleNavClick}>
                Quem Somos
              </Link>
            </li>
            <li className="dropdown-container" ref={equipmentDropdownRef}>
              <div
                className="dropdown-toggle"
                onClick={toggleEquipmentDropdown}
                onKeyDown={(e) => e.key === 'Enter' && toggleEquipmentDropdown()}
                role="button"
                tabIndex={0}
                aria-label="Equipamentos menu"
                aria-expanded={isEquipmentDropdownOpen}
              >
                Equipamentos
                <svg
                  className={`arrow ${isEquipmentDropdownOpen ? 'open' : ''}`}
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="currentColor"
                >
                  <path d="M7 10l5 5 5-5z" />
                </svg>
              </div>
              <ul className={`dropdown-menu ${isEquipmentDropdownOpen ? 'open' : ''}`}>
                <li>
                  <Link to="/munck" onClick={handleNavClick}>
                    Munck
                  </Link>
                </li>
                <li>
                  <Link to="/guindaste" onClick={handleNavClick}>
                    Guindaste
                  </Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/portfolio" onClick={handleNavClick}>
                Fotos
              </Link>
            </li>
            <li>
              <Link to="/contato" onClick={handleNavClick}>
                Contato
              </Link>
            </li>
          </ul>
        </nav>

        <div className="header-icons-group">
          <div className="social-links">
            <a
              href="https://www.instagram.com/megaton.mt/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram da MEGATON"
            >
              <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
              </svg>
            </a>
            <a
              href="https://www.facebook.com/megatonmt/?locale=pt_BR"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook da MEGATON"
            >
              <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
              </svg>
            </a>
          </div>
          <div
            ref={menuToggleRef}
            className="mobile-menu-toggle"
            onClick={toggleMenu}
            onKeyDown={(e) => e.key === 'Enter' && toggleMenu()}
            role="button"
            tabIndex={0}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
